import React, { Component } from 'react';
import EirButton from '../eir-button/EirButton';


class EirWebmailContainer extends Component {
  constructor(props) {
    super(props);
    if (sessionStorage.getItem('webmailLoggedinUser') == null && !window.location.href.includes("opencms")) {
      window.location.href = '/email/login'
    }
  }

  //strips off the html tags received from openCMS and prints only the cotent
  renderContent = (content) => {
    return { __html: content };
  }

  render() {

    return (
      <div className="eir-title-container mb-3 mb-md-5 mt-4 eir-theme-default  container webmail-container">
        <h2 className="eir-title display-4 eir-display-xl-3">{this.props.title}</h2>
        {/* Do not delete - below is to get the image from OpenCMS - may be used later */}
        {/* <img className="mt-4" src={this.props.image} /> */}

        <div className="card mt-4">
          <div className="card-body" >
            <div className="offer-text m-3" style={{ background: "#f4f5f9" }}>
              <p className=" m-3 p-3  eir-text text-left" dangerouslySetInnerHTML={this.renderContent(this.props.text)}></p>
              <div>
                <EirButton
                  type="button"
                  link="/email/payment"
                  text="SIGN UP NOW"
                  className="btn btn-primary mb-3 webmail-btn"
                  name="redirectTo"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

    );
  }
}

export default EirWebmailContainer;
